module.exports = __webpack_public_path__ + "static/media/DPBX9A.crop.f9737b17.jpg";